// 作業系統名稱
const OS = {
    "iOS": "iOS",
    "MacOS": "MacOS",
    "Android": "Android",
    "Windows": "Windows",
    "Linux": "Linux",
    "Ubuntu": "Ubuntu"
};


function parseUserAgent(userAgentString) {
    const userAgent = userAgentString;

    let operatingSystemName = ""; // 作業系統名稱

    if ((userAgent.indexOf("CriOS") > -1 || userAgent.indexOf("Chrome") > -1)
        && userAgent.indexOf("Safari") > -1
        && !(userAgent.indexOf("OPR") > -1)
        && !(userAgent.indexOf("Line") > -1)) { // Chrome瀏覽器，會有(crios(Chrome於iPhone) || chrome) && safari的字樣，但不包含OPR字樣(此為Opera)，也不包含Line字樣(此為Line手機版)
        
        // 拆解User-Agent
        const userAgentArray = userAgent.match(/Mozilla\/[0-9.]+ \(([^\)]+)\) (.+) \(([^\)]+)\) ([^ ]+) (.+)/);

        // 作業系統
        const operatingSystemInfo = chromeBrowserDetectOS(userAgentArray[1]);
        operatingSystemName = operatingSystemInfo.operatingSystemName;
    }
    else if ((userAgent.indexOf("FxiOS") > -1 || userAgent.indexOf("Firefox") > -1) && userAgent.indexOf("Gecko") > -1) { // Firefox瀏覽器
        let tmpUserAgentArray = Array();
        if (userAgent.indexOf("Firefox") > -1) {
            // 拆解User-Agent
            const userAgentArray = userAgent.match(/Mozilla\/[0-9.]+ \(([^\)]+)\) (.+) (.+)/);
            tmpUserAgentArray["operatingSystemInfo"] = firefoxDetectOS(userAgentArray[1]);
        }
        else if (userAgent.indexOf("FxiOS") > -1) { // iOS上的Firxfox
            // 拆解User-Agent
            const userAgentArray = userAgent.match(/Mozilla\/[0-9.]+ \(([^\)]+)\) (.+) \(([^\)]+)\) ([^ ]+) (.+)/);
            tmpUserAgentArray["operatingSystemInfo"] = firefoxDetectOS(userAgentArray[1]);
        }

        // 作業系統
        const operatingSystemInfo = tmpUserAgentArray["operatingSystemInfo"];
        operatingSystemName = operatingSystemInfo.operatingSystemName;
    }
    else if (userAgent.indexOf("Version") > -1 && userAgent.indexOf("Safari") > -1 && !(userAgent.indexOf("Line") > -1)) { // Safari瀏覽器，會有Version && Safari的字樣，且不包含Line字樣(此為Line手機版)
        // 拆解User-Agent
        const userAgentArray = userAgent.match(/Mozilla\/[0-9.]+ \(([^\)]+)\) (.+) \(([^\)]+)\) ([^ ]+) (.+)/);

        // 作業系統
        const operatingSystemInfo = detectAppleOS(userAgentArray[1]);
        operatingSystemName = operatingSystemInfo.operatingSystemName;
    }
    else if (userAgent.indexOf("Trident") > -1) { // IE瀏覽器
        let tmpUserAgentArray = Array();
        if (userAgent.indexOf("rv") > -1) {
            const userAgentArray = userAgent.match(/Mozilla\/[0-9.]+ \(([^\)]+)\) (.+)/);
            tmpUserAgentArray["operatingSystemInfo"] = ieDetectOS(userAgentArray[1]);
        } else if (userAgent.indexOf("MSIE") > -1) {
            const userAgentArray = userAgent.match(/Mozilla\/[0-9.]+ \(([^\)]+)\)/);
            tmpUserAgentArray["operatingSystemInfo"] = ieDetectOS(userAgentArray[1]);
        }

        // 作業系統
        const operatingSystemInfo = tmpUserAgentArray["operatingSystemInfo"];
        operatingSystemName = operatingSystemInfo.operatingSystemName;
    }
    else if (userAgent.indexOf("Line") > -1 && userAgent.indexOf("Mobile") > -1) { // Line app
        // 拆解User-Agent
        const userAgentArray = userAgent.match(/Mozilla\/[0-9.]+ \(([^\)]+)\) (.+) \(([^\)]+)\) ([^ ]+) (.+)/);

        // 作業系統
        const operatingSystemInfo = lineDetectOS(userAgentArray[1]);
        operatingSystemName = operatingSystemInfo.operatingSystemName;
    }

    return {
        "operatingSystemName": operatingSystemName
    }
}


/**
 * 判斷Chrome的User-Agent中的作業系統訊息
 */
function chromeBrowserDetectOS(systemInformation) {
    let operatingSystemName = "";

    // 判斷作業系統、版本
    if (systemInformation.indexOf("Windows") > -1) { // Windows
        operatingSystemName = OS.Windows;
    } else if (systemInformation.indexOf("Linux") > -1 && systemInformation.indexOf("Android") > -1) { // Android
        operatingSystemName = OS.Android;
    } else if (systemInformation.indexOf("X11") > -1 && systemInformation.indexOf("Linux") > -1) { // Linux
        operatingSystemName = OS.Linux;
    } else if (systemInformation.indexOf("Mac OS X") > -1) { // Apple MacOS or iOS
        const operatingSystem = detectAppleOS(systemInformation);
        operatingSystemName = operatingSystem.operatingSystemName;
    }
    return {
        "operatingSystemName": operatingSystemName
    }
}


/**
 * 判斷Firefox的User-Agent中的作業系統訊息
 */
function firefoxDetectOS(systemInformation) {
    let operatingSystemName = "";

    if (systemInformation.indexOf("Windows") > -1) { // Windows
        operatingSystemName = OS.Windows;
    }
    else if (systemInformation.indexOf("Android") > -1) { // Android
        operatingSystemName = OS.Android;
    }
    else if (systemInformation.indexOf("X11") > -1 && systemInformation.indexOf("Linux") > -1) { // Linux
        operatingSystemName = OS.Linux;
        if (systemInformation.indexOf("Ubuntu") > -1) {
            operatingSystemName = OS.Ubuntu;
        }
    }
    else if (systemInformation.indexOf("Mac OS X") > -1) { // Apple MacOS or iOS
        const operatingSystem = detectAppleOS(systemInformation);
        operatingSystemName = operatingSystem.operatingSystemName;
    }

    return {
        "operatingSystemName": operatingSystemName
    }
}


/**
 * 判斷IE的User-Agent中的作業系統訊息
 */
function ieDetectOS(systemInformation) {
    let operatingSystemName = OS.Windows;
    return {
        "operatingSystemName": operatingSystemName
    }
}


/**
 * 判斷Line的User-Agent中的作業系統訊息
 */
function lineDetectOS(systemInformation) {
    let operatingSystemName = "";

    if (systemInformation.indexOf("Android") > -1) { // Android
        operatingSystemName = OS.Android;
    }
    else if (systemInformation.indexOf("Mac OS X") > -1) { // Apple MacOS or iOS
        const operatingSystem = detectAppleOS(systemInformation);
        operatingSystemName = operatingSystem.operatingSystemName;
    }

    return {
        "operatingSystemName": operatingSystemName
    }
}


/**
 * 判斷Apple OS相關訊息
 */
function detectAppleOS(systemInformation) {
    let operatingSystemName = "";

    if (systemInformation.indexOf("iPhone") > -1 || systemInformation.indexOf("iPad") > -1) {
        operatingSystemName = OS.iOS;
    }
    else if (systemInformation.indexOf("Macintosh") > -1) {
        operatingSystemName = OS.MacOS;
    }

    return {
        "operatingSystemName": operatingSystemName
    }
}



export default {
    OS,
    parseUserAgent
}